import { getPaymentGuidAction } from 'actions/getPaymentGuidAction';
import { getRenewalPaymentHandler } from 'actions/getRenewalPaymentHandler';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { PaymentPortalPage } from '../../../../shared/paymentPortalPage';

interface AnnualPaymentProps {
  selectedPolicy: FullPolicyData;
  paymentAmount: number;
  policyDetailsId: string;
  historyId: number;
}

export const AnnualPayment = ({
  selectedPolicy,
  paymentAmount,
  policyDetailsId,
  historyId
}: AnnualPaymentProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const authentication = useAppSelector((state) => state.authentication);
  const { isAgent, email, isAuthenticated } = authentication;

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(
        getPaymentGuidAction({
          selectedPolicy,
          amount: Number(paymentAmount),
          source: 'RenewalJourney',
          username: email,
          isAgent,
          policyDetailsId,
          historyId
        })
      );
    }
  }, [isAuthenticated]);

  const overrides = getRenewalPaymentHandler({
    selectedPolicy,
    policyDetailsId,
    historyId,
    email,
    isAgent
  });

  return <PaymentPortalPage paymentMessageOverrides={overrides} />;
};
